<script setup>
const props = defineProps({
  // 接口函数
  options: {
    type: Array,
    default: null,
  },
  // 目标键
  targetKey: {
    type: String,
    default: 'id'
  },
  // 目标值
  targetValue: {
    type: String,
    default: 'name',
  },
  // 当前的值
  value: [Number, String],
});

const values = computed(() => {
  return (props.options.find((item) => item[props.targetKey] === props.value) || {})[props.targetValue];
});

</script>

<template>
  <span>{{ values }}</span>
</template>

<style scoped>

</style>
